import React, { useContext } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { Link } from 'app/src/utils/routing';

import { colors, Text } from './styles';

const fontSize = props => {
  if ('small' === props.size) {
    return '12px';
  } else if ('large' === props.size) {
    return '16px';
  } else {
    return '14px';
  }
}

export const ContentContainer = styled(View)`
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  width: 100%;
  max-width: 100%;
  height: 'fit-content';
  gap: ${props => props.isMobile ? '1000px' : '24px'};
`;

export const ContentColumn = styled(View)`
  flex: 1;
  gap: 24px;
  min-width: ${props => props.isMobile ? 'fit-content' : '200px'};
  min-height: fit-content;
`;

export const ContentColumnNoGap = styled(View)`
  flex: 1;
`;

export const ContentBox = styled(View)`
  padding: ${props => props.mobilePadding ? '12px' : '24px'};
  background-color: white;
  border-radius: 16px;
  gap: 12px;
  ${props => props.margin20 ? `marginTop: 20px;` : ''}
  ${props => props.noTopRadius ?
    'border-top-left-radius: 0px; border-top-right-radius: 0px;' :
    ''
  };
  margin-bottom: ${props => props.isMobile ? '100px' : '0px'}
  min-height: fit-content;
   &::after {
    content: 'XXX';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: red;
  }
`;

export const ContentHeaderRow = styled(View)`
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const ContentHeader = styled(Text)`
  font-size: 20px;
  font-weight: 600;
  ${props => props.center ? 'align-self: center;' : ''}
`;

export const ContentSubHeader = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  ${props => props.center ? 'align-self: center;' : ''}
  color: ${props => props.color || '#000'}
`;

export const ContentBoxHeader = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  ${props => props.center ? 'align-self: center;' : ''}
`;

export const ContentHighlight = styled(View)`
  background-color: ${colors.highlightBackground};
  padding-vertical: 6px;
  padding-horizontal: 12px;
  align-items: center;
  border-radius: 20px;
`;

export const ContentHighlightLabel = styled(Text)`
  color: ${colors.highlightText};
  font-size: ${fontSize};
  font-weight: 600;
`;

export const ContentValueRow = styled(View)`
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  flex-wrap: wrap;
  width: 100%;
  ${props => props.negativeTopMargin ? 'marginTop: -15px;' : ''};
  min-height: 'fit-content';
`;

export const ContentLabel = styled(Text)`
  font-size: ${fontSize};
  ${props => props.highlight ? 'color: white;' : ''}
  ${props => props.bold ? 'font-weight: 600;' : ''}
`;

export const ContentValue = styled(Text)`
  color: ${props => props.color || 'black'};
  font-size: ${fontSize};
  font-weight: 600;
`;

export const ContentDots = styled(View)`
  height: 12px;
  margin-horizontal: 14px;
  border-bottom-width: 1px;
  border-bottom-color: lightgray;
  border-bottom-style: dashed;
  flex: 1;
`;

export const ContentValueBox = styled(View)`
  gap: 8px;

  ${props => props.highlight ? `
    background-color: ${colors.highlightText};
  ` : ''}

  ${props => props.color ? `
    background-color: ${props.color}
  ` : null}

  ${props => !props.highlight && !props.color ?
    `
      border-width: 1px;
      border-style: solid;
      border-color: ${colors.tableBorder};
    ` : ''
  }

  border-radius: 8px;
  padding-vertical: 12px;
  padding-horizontal: 12px;

  ${props => props.width ? `
    width: ${props.width}
  ` : ''}
`;

export const ContentColumnBox = styled(View)`
  flex-direction: row;
  flex: 1;
  border-width: 1px;
  border-style: solid;
  border-color: ${colors.tableBorder};
  border-radius: 8px;
  padding-vertical: 15px;
  padding-horizontal: 20px;
`;

export const ActionButton = styled(Pressable)`
  padding-vertical: 6px;
  padding-horizontal: 12px;
  border-width: 1px;
  border-style: solid;
  border-color: ${colors.tableBorder};
  border-radius: 8px;
  ${props => props.center ? 'margin-horizontal: auto;' : ''}
`;

export const ActionLabel = styled(Text)`
  font-size: 12px;
`;

export const ContentValueGraphContainer = styled(View)`
  height: 100;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10;
  margin-top: 15px;
`;

export const ContentValueGraph = styled(View)`
  height: ${props => props.height};
  background-color: ${props => props.color === 'grey' ? colors.contentBackground : colors.highlightBackground};
  border-top-width: 1px;
  border-top-color: ${props => props.color === 'grey' ? colors.lightAccent : colors.highlightText}
  width: 60px;
  align-self: flex-end;
  align-content: center;
  justify-content: center;
`;

export const ContentValueGraphText = styled(Text)`
  font-weight: 600;
  align-self: center;
  color: ${props => props.color === 'black' ? 'black' : colors.highlightText}
`;

export const ContentTaskButton = styled(Pressable)`
  background-color: ${props => props.color};
  border-width: 1px;
  border-color: ${props => props.color};
  border-radius: 10px;
  display: flex !important;
  flex-direction: row;
  justify-content: space-between !important;
  width: 100%;
  padding: 10px;
`;

export const ContentTaskButtonText = styled(Text)`
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.color}
`;

export const Content = {
  Container: ContentContainer,
  Column: ContentColumn,
  ColumnNoGap: ContentColumnNoGap,
  Box: ContentBox,
  ColumnBox: ContentColumnBox,
  HeaderRow: ContentHeaderRow,
  Header: ContentHeader,
  SubHeader: ContentSubHeader,
  BoxHeader: ContentBoxHeader,
  Highlight: ContentHighlight,
  HighlightLabel: ContentHighlightLabel,
  ValueRow: ContentValueRow,
  Label: ContentLabel,
  Value: ContentValue,
  Dots: ContentDots,
  ValueBox: ContentValueBox,
  ActionButton: ActionButton,
  ActionLabel: ActionLabel,
  ValueGraphContainer: ContentValueGraphContainer,
  ValueGraph: ContentValueGraph,
  ValueGraphText: ContentValueGraphText,
  TaskButton: ContentTaskButton,
  TaskButtonText: ContentTaskButtonText
};

export default Content;
